import { State } from '../interfaces/state';

export type Type = 'take' | 'skip' | 'filter' | 'sort' | 'reorder' | 'group' | 'column';

export class StateChangeEvent {

    public type: Type;

    public state: State;

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/classes/state-change-event.ts